module.exports = __webpack_public_path__ + "eg.svg?0937143657d85d2f6342833231d48065";